import {
  actionCreator,
  checkHttpStatus,
  DELETE_MASTERTHERAPY,
  masterTherapyActionTypes,
  GET_MASTERTHERAPY,
  GET_MASTERTHERAPY_BY_ID,
  jsonApiHeader,
  POST_MASTERTHERAPY,
  showErrorMessage,
  showSuccessMessage,
} from '../constants/ApiConstants';
import { checkHttpStatusAuthCheck, createSearchUrlForCustomAPI, showWarningMessage } from '../../../../../actions/utilAction';

export const getMasterTherapyList = (searchObj) => {

  return (dispatch, getState) => {
    dispatch(actionCreator(masterTherapyActionTypes.get_master_therapy.REQUEST));

    let query_params = createSearchUrlForCustomAPI(searchObj);;
    fetch(`${GET_MASTERTHERAPY}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
    .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
        dispatch(actionCreator(masterTherapyActionTypes.get_master_therapy.SUCCESS, response));
        } else {
          dispatch(actionCreator(masterTherapyActionTypes.get_master_therapy.SUCCESS, null));
        }
      })
      .catch(function(error) {
        // errorHandler(error);
      });
  };
};

export const saveMasterTherapy = (formData) => {
  let postData = JSON.stringify(formData);
  return (dispatch, getState) => {
    dispatch(actionCreator(masterTherapyActionTypes.post_master_therapy.REQUEST));
    fetch(`${POST_MASTERTHERAPY}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: postData,
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(masterTherapyActionTypes.post_master_therapy.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(masterTherapyActionTypes.post_master_therapy.SUCCESS, null));
        }
      });
  };
};

export const deleteMasterTherapy = (id) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(masterTherapyActionTypes.delete_master_therapy.REQUEST));

    fetch(`${DELETE_MASTERTHERAPY}?therapyId=${id}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(masterTherapyActionTypes.delete_master_therapy.SUCCESS, response));
          let searchObj = {
            sort_fields: 'id',
            sort_order:  'desc',
            contain_filters: { SearchText: null },
            pageNumber: 1,
          };
          dispatch(getMasterTherapyList(searchObj));
        } else if (response.statusCode === 401) {
          showWarningMessage(response.message);
          dispatch(actionCreator(masterTherapyActionTypes.delete_master_therapy.SUCCESS, null));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(masterTherapyActionTypes.delete_master_therapy.SUCCESS, null));
        }
      }).catch(function(error) {
        // console.log(error);
      });
  };
};
export const getMasterTherapyById = (Id) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(masterTherapyActionTypes.get_master_therapy_by_id.REQUEST));

    fetch(`${GET_MASTERTHERAPY_BY_ID}?therapyId=${Id}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
        dispatch(actionCreator(masterTherapyActionTypes.get_master_therapy_by_id.SUCCESS, response));
        } else {
          dispatch(actionCreator(masterTherapyActionTypes.get_master_therapy_by_id.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error --', error);
      });
  };
};




// WEBPACK FOOTER //
// ./src/modules/Masters/components/masterTherapy/actions/MasterTherapyActions.js